import { render, staticRenderFns } from "./UcSuggestPropertyOption.yaml?vue&type=template&id=0cb4bf37&component"
import script from "./UcSuggestPropertyOption.yaml?vue&type=script&lang=ts&component"
export * from "./UcSuggestPropertyOption.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports